import { render, staticRenderFns } from "./ModalVerHistorial.vue?vue&type=template&id=43479194&"
import script from "./ModalVerHistorial.vue?vue&type=script&lang=ts&"
export * from "./ModalVerHistorial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports